import { redirectWithClientId } from './url';
import { SCRIPTING_URL, SCRIPTING_PLUGIN_URL, FHA_URL, PLANTING_REPORT_URL, APPLICATION_REPORT_URL } from '../constants/urls';
import { FieldFeature } from '../types';

const features = {
  WEATHER: [
    'HistoricWeather',
    'Rainfall',
    'Weather',
    'Radar',
    'PendingWeather',
    'Forecast',
    'Hail',
  ],
  FHA: ['FieldHealthAdvisor'],
  SCRIPTING: ['ManualScripting', 'AdvancedZone', 'AdvancedRate'],
  SCOUTING: ['Scouting'],
  PLANTING_REPORT: ['PlantingReport']
};

const has = (collection, values) => collection.some((item) => values.includes(item));

/**
 * Validates if a field has a weather feature, based on: https://goo.gl/C5GYSK
 * @param {Array} fieldFeatures the field features\
 * @return {Boolean} wether the field has weather enabled or not.
 */
export const hasWeather = (fieldFeatures) =>
  has(features.WEATHER, fieldFeatures);

/**
 * Validates if a field has an FHA feature, based on: https://goo.gl/C5GYSK
 * @param {Array} fieldFeatures the field features\
 * @return {Boolean} wether the field has FHA enabled or not.
 */
export const hasFha = (fieldFeatures) => has(features.FHA, fieldFeatures);

/**
 * Validates if a field has an Scouting feature, based on: https://goo.gl/C5GYSK
 * @param {Array} fieldFeatures the field features\
 * @return {Boolean} wether the field has FHA enabled or not.
 */
export const hasScouting = (fieldFeatures) => has(features.SCOUTING, fieldFeatures);

/**
 * Validates if a field has an Scouting feature, based on: https://goo.gl/C5GYSK
 * @param {Array} fieldFeatures the field features\
 * @return {Boolean} wether the field has FHA enabled or not.
 */
export const hasFieldViewSpatialDisplay = (fieldFeatures) => has([FieldFeature.FIELD_VIEW_SPATIAL_DISPLAY], fieldFeatures);

/**
 * Validates if a field has an scripting feature, based on: https://goo.gl/C5GYSK
 * @param {Array} fieldFeatures the field features\
 * @return {Boolean} wether the field has scripting enabled or not.
 */
export const hasScripting = (fieldFeatures) =>
  has(features.SCRIPTING, fieldFeatures);

export const hasPlantingReport = (fieldFeatures) =>
  has(features.PLANTING_REPORT, fieldFeatures);

export const onClickPrescriptions = (fieldId: string, isScriptCreatorAPlugin = false) => () => {
  redirectWithClientId(isScriptCreatorAPlugin ? SCRIPTING_PLUGIN_URL : SCRIPTING_URL, {
    'field-id': fieldId,
  });
};

export const onClickPlantingReports = (season: string) => () => {
  redirectWithClientId(PLANTING_REPORT_URL, {
    season,
  });
};

export const onClickApplicationReport = (season: string) => () => {
  redirectWithClientId(APPLICATION_REPORT_URL, {
    season,
  });
};

export const onClickFHA = (fieldId: string) => () =>
  redirectWithClientId(FHA_URL, {
    'field-id': fieldId,
  });
